import { render, staticRenderFns } from "./assets-box.vue?vue&type=template&id=1c0ecdcb&scoped=true&"
import script from "./assets-box.vue?vue&type=script&lang=js&"
export * from "./assets-box.vue?vue&type=script&lang=js&"
import style0 from "./assets-box.vue?vue&type=style&index=0&id=1c0ecdcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ecdcb",
  null
  
)

export default component.exports